// removed by extract-text-webpack-plugin
module.exports = {"cta":"src-components-modules-Cta-CtaDemo-style----general-module---cta---35v6-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Cta/CtaDemo/style/general.module.css
// module id = 250
// module chunks = 47877783677342 56719701542624 281026976107462